/**
 * Announces that the visitor has just accepted, for GTM triggers to match.
 *
 * Add it as a Custom Event trigger on any tag that should fire on acceptance
 * rather than waiting for the next page load. Inert until something in the
 * container listens for it.
 *
 * The container id is not here: nuxt.config.js is read before this module
 * exists, and it is now the only place that needs the literal.
 */
export const CONSENT_GRANTED_EVENT = 'consent_granted';
